.core-scroll-container {
  /* Removes scrollbars in firefox */
  overflow: hidden;
  display: flex;
  align-items: center;
}

.core-scroll-element {
  flex-grow: 1;

  /* hide scrollbars */
  /*  - in Firefox */
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;

  /* - in Safari, Chrome, Edge */
  &::-webkit-scrollbar {
    width: 0 !important;
    display: none;
  }
}

.list {
  display: flex;
  align-items: center;
  gap: var(--rds-spacing--8);
  padding: 0;
  list-style-type: none;
}

.list li:first-child {
  margin-left: var(--scroller-margin);
}

.list li:last-child {
  margin-right: var(--scroller-margin);
}

.navigation-arrow {
  /* display scrollArrows for desktop but never for touch devices */
  @media (pointer: fine) {
    display: block !important;
  }
}
